import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class FabLoadingSpinnerComponent {
    constructor() {
        this.withOverlay = true;
        this.color = 'primary';
        this.mode = 'indeterminate';
        this.value = 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabLoadingSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.7", type: FabLoadingSpinnerComponent, isStandalone: true, selector: "fab-loading-spinner", inputs: { withOverlay: "withOverlay", color: "color", mode: "mode", value: "value" }, ngImport: i0, template: "<!--\n  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.\n  ~ This information is confidential and proprietary to GM Global Technology\n  ~ Operations LLC and may not be used, modified, copied or distributed.\n  -->\n\n<div [class.overlay]=\"withOverlay\">\n  <mat-progress-spinner\n    id=\"fab-loading-spinner\"\n    aria-busy=\"true\"\n    aria-label=\"Loading Spinner\"\n    aria-valuetext=\"loading\"\n    [color]=\"color\"\n    [mode]=\"mode\"\n    [value]=\"value\"\n    class=\"material-spinner-center-position\"\n  ></mat-progress-spinner>\n</div>\n", styles: ["/*!\n * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.\n * This information is confidential and proprietary to GM Global Technology\n * Operations LLC and may not be used, modified, copied or distributed.\n */.material-spinner-center-position{position:fixed;top:50%;left:50%;margin-top:-50px;margin-left:-50px;z-index:9999}.overlay{position:fixed;width:100%;height:100%;inset:0;background-color:#ffffff80;z-index:9998!important;cursor:pointer}:host-context(.fab-dark-theme) .overlay{background-color:#00000080}\n"], dependencies: [{ kind: "ngmodule", type: MatProgressSpinnerModule }, { kind: "component", type: i1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabLoadingSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fab-loading-spinner', standalone: true, imports: [MatProgressSpinnerModule], template: "<!--\n  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.\n  ~ This information is confidential and proprietary to GM Global Technology\n  ~ Operations LLC and may not be used, modified, copied or distributed.\n  -->\n\n<div [class.overlay]=\"withOverlay\">\n  <mat-progress-spinner\n    id=\"fab-loading-spinner\"\n    aria-busy=\"true\"\n    aria-label=\"Loading Spinner\"\n    aria-valuetext=\"loading\"\n    [color]=\"color\"\n    [mode]=\"mode\"\n    [value]=\"value\"\n    class=\"material-spinner-center-position\"\n  ></mat-progress-spinner>\n</div>\n", styles: ["/*!\n * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.\n * This information is confidential and proprietary to GM Global Technology\n * Operations LLC and may not be used, modified, copied or distributed.\n */.material-spinner-center-position{position:fixed;top:50%;left:50%;margin-top:-50px;margin-left:-50px;z-index:9999}.overlay{position:fixed;width:100%;height:100%;inset:0;background-color:#ffffff80;z-index:9998!important;cursor:pointer}:host-context(.fab-dark-theme) .overlay{background-color:#00000080}\n"] }]
        }], propDecorators: { withOverlay: [{
                type: Input
            }], color: [{
                type: Input
            }], mode: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * `FabLoadingSpinnerComponent` is now standalone.  You can import the component directly.
 * `NgModule` left in place for backwards compatibility.
 */
class FabLoadingSpinnerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabLoadingSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: FabLoadingSpinnerModule, imports: [FabLoadingSpinnerComponent], exports: [FabLoadingSpinnerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabLoadingSpinnerModule, imports: [FabLoadingSpinnerComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabLoadingSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FabLoadingSpinnerComponent],
                    exports: [FabLoadingSpinnerComponent],
                }]
        }] });

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * Created by michael faith on 4/7/2020.
 */

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * Created by michael faith on 4/7/2020.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FabLoadingSpinnerComponent, FabLoadingSpinnerModule };
